module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres82e-reserve",
    attrs: {
      "id": "hres82e-reserve"
    }
  }, [_c('div', {
    staticClass: "hrms-staappr"
  }, [_c('div', {
    staticClass: "header-paper clearfix"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES82EC3']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.indexSelected.roomno) + " - " + _vm._s(_vm.indexSelected.desc_roomno))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-topic border-color-skin"
  }, [_c('i', {
    staticClass: "fa fa-pencil margin-r-5 color-skin"
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin"
  }, [_vm._v(_vm._s(_vm.descCodapp))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['20']))]), _vm._v(" "), _c('hrms-datepicker', {
    attrs: {
      "disabled": "disabled",
      "name": "dtereq"
    },
    model: {
      value: (_vm.detail.dtereq),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtereq", $$v)
      },
      expression: "detail.dtereq"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['30']))]), _vm._v(" "), _c('hrms-datepicker', {
    attrs: {
      "disabled": "disabled",
      "name": "dtereq"
    },
    model: {
      value: (_vm.dateSelected),
      callback: function($$v) {
        _vm.dateSelected = $$v
      },
      expression: "dateSelected"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['40']))]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-xs-6 clear-padding"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['50']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:HH:mm'),
      expression: "'required|date_format:HH:mm'"
    }],
    class: {
      'input-error': _vm.errors.has('timstrt')
    },
    attrs: {
      "data-vv-name": "timstrt",
      "data-vv-value-path": "inputTime",
      "name": "timstrt",
      "has-error": _vm.errors.has('timstrt'),
      "disabled": !_vm.presentConFlg
    },
    model: {
      value: (_vm.detail.timstrt),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timstrt", $$v)
      },
      expression: "detail.timstrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timstrt')),
      expression: "errors.has('timstrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timstrt')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 clear-padding"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['60']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:HH:mm'),
      expression: "'required|date_format:HH:mm'"
    }],
    class: {
      'input-error': _vm.errors.has('timend')
    },
    attrs: {
      "data-vv-name": "timend",
      "data-vv-value-path": "inputTime",
      "name": "timend",
      "has-error": _vm.errors.has('timend'),
      "disabled": !_vm.presentConFlg
    },
    model: {
      value: (_vm.detail.timend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timend", $$v)
      },
      expression: "detail.timend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timend')),
      expression: "errors.has('timend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timend')))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['70']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio col-xs-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.staappr),
      expression: "detail.staappr"
    }],
    attrs: {
      "type": "radio",
      "value": "B",
      "disabled": !_vm.presentConFlg
    },
    domProps: {
      "checked": _vm._q(_vm.detail.staappr, "B")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "staappr", "B")
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES82EC3']['80']) + "\n                    "), ((_vm.detail.staappr === 'B' || _vm.detail.staappr === 'C') && (_vm.detail.desc_codempid.trim() !== '')) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.labels['HRES82EC3']['100']) + " " + _vm._s(_vm.detail.desc_codempid) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-xs-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.staappr),
      expression: "detail.staappr"
    }],
    attrs: {
      "type": "radio",
      "value": "C",
      "disabled": !_vm.presentConFlg
    },
    domProps: {
      "checked": _vm._q(_vm.detail.staappr, "C")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "staappr", "C")
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES82EC3']['90']) + "\n                    "), ((_vm.detail.staappr === 'C') && (_vm.detail.desc_codappr.trim() !== '')) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.labels['HRES82EC3']['110']) + " " + _vm._s(_vm.detail.desc_codappr) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.staappr),
      expression: "detail.staappr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "hidden",
      "data-vv-name": "staappr",
      "has-error": _vm.errors.has('staappr')
    },
    domProps: {
      "value": (_vm.detail.staappr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "staappr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('staappr')),
      expression: "errors.has('staappr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('staappr')))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['120']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.object),
      expression: "detail.object"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:250'),
      expression: "'max:250'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "object",
      "id": "object",
      "maxlength": "250",
      "data-vv-name": "object",
      "disabled": !_vm.presentConFlg,
      "has-error": _vm.errors.has('object')
    },
    domProps: {
      "value": (_vm.detail.object)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "object", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('object')),
      expression: "errors.has('object')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('object')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(250)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['130']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.remark),
      expression: "detail.remark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:250'),
      expression: "'max:250'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "id": "remark",
      "maxlength": "250",
      "data-vv-name": "remark",
      "disabled": !_vm.presentConFlg,
      "has-error": _vm.errors.has('remark')
    },
    domProps: {
      "value": (_vm.detail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(250)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES82EC3']['140']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.qtypers),
      expression: "detail.qtypers"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'input-error': _vm.errors.has('qtypers')
    },
    attrs: {
      "type": "number",
      "name": "qtypers",
      "id": "qtypers",
      "data-vv-name": "qtypers",
      "has-error": _vm.errors.has('qtypers'),
      "disabled": !_vm.presentConFlg
    },
    domProps: {
      "value": (_vm.detail.qtypers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "qtypers", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC3']['150']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('qtypers')),
      expression: "errors.has('qtypers')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('qtypers')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('detail')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.presentConFlg),
      expression: "presentConFlg"
    }],
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.presentConFlg),
      expression: "!presentConFlg"
    }],
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e491a58e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres82e/reserve.vue
// module id = 4002
// module chunks = 1